class ErrorMessageController extends window.StimulusController {
  static targets = ["errorMessage", "errorMessageWrapper"];
  static values = {
    autoDismiss: Boolean,
    milliseconds: Number,
    lineItemKey: String,
  };

  toggleErrorMessage({ detail: { errorMessage } }) {
    this.errorMessageWrapperTarget.classList.toggle("tw-hidden", !errorMessage);
    this.errorMessageTarget.textContent = errorMessage;

    if (this.autoDismissValue) {
      setTimeout(() => {
        this.errorMessageWrapperTarget.classList.add("tw-hidden");
      }, this.millisecondsValue);
    }
  }
}

Stimulus.register("error-message", ErrorMessageController);
